import React from 'react';
import { Typography } from '@mui/material';

const PricesIncludeTaxNote: React.FC<{ show?: boolean }> = ({ show }) =>
  show ? (
    <Typography variant="caption" color="text.secondary" display="block">
      IVA incluido
    </Typography>
  ) : null;

export default PricesIncludeTaxNote;
